export default __webpack_public_path__ + "14a5c76368d07ac37f5984ac2b37f6a8.svg";